<template>
  <span class="flex-1 text-center whitespace-nowrap tabular-nums">
    <template v-if="price && locked">
      <span class="blur-sm select-none text-gray-500" aria-label="Members only">??</span>
      <AddPill class="ml-1" :selection="selection" />
    </template>
    <template v-else-if="price">
      <span v-if="view === 'odds'" class="inline-flex flex-col items-center leading-tight align-middle" :title="title">
        <template v-if="price.odds">
          <span :class="value ? 'text-[#22c55e] font-semibold' : ''">{{ format(price.odds) }}</span>
          <span class="text-[10px] text-gray-500">fair {{ format(100 / price.p) }}</span>
        </template>
        <template v-else>
          <span class="text-gray-500">fair {{ format(100 / price.p) }}</span>
          <span class="text-[10px] text-gray-400">no price yet</span>
        </template>
      </span>
      <span v-else-if="view === 'value'" :title="title">
        <span v-if="edge !== null" class="chip" :class="edgeClass(edge * 100)">{{ formatEdge(edge * 100) }}</span>
        <span v-else class="text-[10px] text-gray-400">no price</span>
      </span>
      <span
        v-else
        :class="value ? 'text-[#22c55e] font-semibold' : ''"
        :title="title"
        >{{ Math.round(price.p) }}%</span
      >
      <AddPill class="ml-1" :selection="selection" />
    </template>
    <template v-else>-</template>
  </span>
</template>

<script>
import AddPill from "./AddPill.vue";
import { formatOdds, formatEdge, edgeClass } from "../../odds";
import { propsLocked } from "./propValue";

const LABELS = {
  sot: (name, line) => `${name} ${line} ${line === "1+" ? "shot" : "shots"} on target`,
  shots: (name, line) => `${name} ${line} shots`,
  fouls: (name, line) => `${name} ${line} ${line === "1+" ? "foul" : "fouls"}`,
  tackles: (name, line) => `${name} ${line} ${line === "1+" ? "tackle" : "tackles"}`,
  goal: (name) => `${name} anytime goalscorer`,
  card: (name) => `${name} to be booked`,
};

export default {
  name: "PropCell",
  components: { AddPill },
  props: {
    // the match-info `props` block: {home_team: [...], away_team: [...]}
    playerProps: { type: Object, default: null },
    side: { type: String, required: true }, // home_team | away_team
    item: { type: Object, required: true }, // a goal_scorers / cards_fouls row
    market: { type: String, required: true },
    line: { type: String, default: "" },
    slipMatch: { type: Object, required: true },
  },
  methods: {
    // always decimal inside the player tables: fractions like 129/10 are too wide for the columns
    format(decimal) {
      return formatOdds(decimal, "decimal");
    },
    formatEdge,
    edgeClass,
  },
  computed: {
    view() {
      return this.$store.state.betslip.propView;
    },
    // our player numbers are for members; free accounts and visitors see the Premier League only
    locked() {
      return propsLocked(this.$store, this.slipMatch);
    },
    player() {
      const rows = (this.playerProps && this.playerProps[this.side]) || [];
      if (!rows.length) return null;
      if (this.item.player_id) {
        const byId = rows.find((r) => r.player_id === this.item.player_id);
        if (byId) return byId;
      }
      return rows.find((r) => r.name === this.item.name) || null;
    },
    price() {
      const market = this.player && this.player.markets && this.player.markets[this.market];
      const price = market && market[this.line];
      // a player we expect not to play (injured, suspended) has p 0: show "-", not a bet
      return price && price.p !== null && price.p !== undefined && price.p > 0 ? price : null;
    },
    edge() {
      if (!this.price || !this.price.odds) return null;
      return (this.price.p / 100) * this.price.odds - 1;
    },
    value() {
      return this.edge !== null && this.edge >= 0.05;
    },
    title() {
      const parts = [`we make it ${Math.round(this.price.p)}%`];
      if (this.price.odds) parts.push(`bet365 ${this.price.odds}`);
      if (this.player && this.player.n) parts.push(`${this.player.n} games`);
      return parts.join(" · ");
    },
    selection() {
      const name = this.player.name || this.item.name;
      return {
        id: `${this.slipMatch.match_id}|${this.market}|${this.player.player_id}|${this.line}`,
        label: LABELS[this.market](name, this.line),
        match: this.slipMatch.title,
        match_id: this.slipMatch.match_id,
        kickoff: this.slipMatch.kickoff,
        side: this.side === "home_team" ? "home" : "away",
      };
    },
  },
};
</script>
